import { ApolloError } from "@apollo/client";

import { HorizontalLeftAlignContainer, HorizontalRightAlignContainer } from "@/styles/flex";

import {
  CenterInnerModalContainer,
  ModalHeader,
  ModalOuterContainer,
  ModalStyleProps,
  RightSideInnerModalContainer,
  StyledChevronBack,
} from "./styles";

interface ModalProps extends ModalStyleProps {
  open: boolean;
  onClose: () => void;
  title: string;
  error?: ApolloError;
  modalClickable?: JSX.Element;
  editView?: boolean;
  rightSide?: boolean;
}

export const Modal: React.FC<ModalProps> = (props) => {
  if (!props.open) {
    return <></>;
  }
  const InnerContainer = props.rightSide ? RightSideInnerModalContainer : CenterInnerModalContainer;

  // Explicitly typing the event for the onClick handler
  const handleInnerClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <ModalOuterContainer onClick={() => props.onClose()}>
      <InnerContainer width={props.width} onClick={handleInnerClick}>
        <ModalHeader>
          <HorizontalLeftAlignContainer>
            {!props.editView && <StyledChevronBack onClick={() => props.onClose()} />}
            {props.title}
          </HorizontalLeftAlignContainer>
          <HorizontalRightAlignContainer>{props.modalClickable}</HorizontalRightAlignContainer>
        </ModalHeader>
        {props.error && "Error loading data"}
        {props.children}
      </InnerContainer>
    </ModalOuterContainer>
  );
};
